import { AuthService } from './../../../../service/auth.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faCamera, faKey, faLock, faUser } from '@fortawesome/free-solid-svg-icons';
import { Callback } from '../../login.component';
import { AgentDto } from '../../../../service/dto';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { concatMap, finalize, Observable, Observer } from 'rxjs';
import { HttpEventType } from '@angular/common/http';
import { HttpAgentService } from '../../../../service/http-agent.service';

@Component({
    selector: 'app-register-document-front',
    templateUrl: './register-document-front.component.html',
    styleUrl: './register-document-front.component.scss',
    standalone: false
})
export class RegisterDocumentFrontComponent {
	@Input() agent!: AgentDto;
	@Output("doUpdateState") doUpdateState = new EventEmitter<Callback>();

	uploadProgress = 0;
	submitting = false;
	loading = false;
	avatarUrl?: string;
	imagePreview: string | ArrayBuffer | null = null;
	canGotoNext=false;


	constructor(private authService: AuthService, private agentService: HttpAgentService) {

	}
	private getBase64(img: File, callback: (img: string) => void): void {
		const reader = new FileReader();
		reader.addEventListener('load', () => callback(reader.result!.toString()));
		reader.readAsDataURL(img);
	}
	handleChange(info: { file: NzUploadFile }): void {
		switch (info.file.status) {
			case 'uploading':
				this.loading = true;
				break;
			case 'done':
				// Get this url from response in real world.
				this.getBase64(info.file!.originFileObj!, (img: string) => {
					this.loading = false;
					this.avatarUrl = img;
				});
				break;
			case 'error':
				this.loading = false;
				break;
		}
	}

	beforeUpload = (file: NzUploadFile, fileList: NzUploadFile[]): boolean => {
		if (!file.type!.startsWith('image/')) {
			return false;
		}
		const reader = new FileReader();
		reader.onload = () => {
			this.imagePreview = reader.result;
		};
		reader.readAsDataURL(file as any as File);

		return true;
	}
	customUpload = (item: NzUploadXHRArgs): any => {
		this.uploadProgress = 0;

		this.submitting = true;
		this.canGotoNext=false;
		const subscription = this.authService.doRegisterAuthWithOtp(this.agent).pipe(
			concatMap(authResponse => this.agentService.doRegisterUploadFrontDocument(item.file as any, authResponse.jwtToken!)),
			finalize(() => this.submitting = false)
		)
			.subscribe({
				next: (event) => {
					if (event.type === HttpEventType.Response) {
						this.uploadProgress = 100;
						const agent = event.body as AgentDto;
						agent.otp = this.agent.otp;
						agent.username=this.agent.username;
						agent.password=this.agent.password;

						switch (agent.status) {
							case 'PendingRegistration': {
								this.canGotoNext=true;
								break;
							}
							case 'PendingApproval': return this.doUpdateState.emit({ mode: 'PendingApproval', agent: agent });
							case 'Rejected': return this.doUpdateState.emit({ mode: 'Rejected', agent: agent });
							case 'Approved': return this.doUpdateState.emit({ mode: 'CapturePassword', agent: agent });
							case 'Blocked': return this.doUpdateState.emit({ mode: 'Blocked', agent: agent });
							case 'Suspended': return this.doUpdateState.emit({ mode: 'Suspended', agent: agent });
						}
					}
					if (event.type === HttpEventType.UploadProgress) {
						console.log(`Event Total: [${event.total} - Event Loaded [${event.loaded}]]`);
						const percentage = Math.round((100 * event.loaded) / (event.total ?? event.loaded));
						this.uploadProgress = percentage == 100 ? 99 : percentage;
					}
				},
				error: (err) => item.onError!(err, item.file!)
			});
		return { abort() { subscription.unsubscribe(); } };
	}
	enableNext(): boolean {
		return this.submitting == false && this.agent.portraitImage != undefined;
	}
	doNext() {
		this.doUpdateState.emit({ mode: 'CaptureRegistrationDocumentBack', agent: this.agent });
	}
}
